export const EXPENSE_STATUS_LABELS: Record<string, string> = {
  draft: "ຮ່າງ",
  submitted: "ສົ່ງອະນຸມັດ",
  approved: "ອະນຸມັດແລ້ວ",
  rejected: "ປະຕິເສດ",
  paid: "ຈ່າຍແລ້ວ",
  closed: "ປິດແລ້ວ",
  cancelled: "ຍົກເລີກ",
  voided: "ຍົກເລີກ",
};

export const EXPENSE_STATUS_BADGE_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  draft: "outline",
  submitted: "outline",
  approved: "default",
  rejected: "destructive",
  paid: "secondary",
  closed: "secondary",
  cancelled: "outline",
  voided: "destructive",
};

export const EXPENSE_PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: "ເງິນສົດ",
  bank_transfer: "ໂອນທະນາຄານ",
  other: "ອື່ນໆ",
};

export function formatExpenseAmount(amount: number): string {
  return `${amount.toLocaleString("lo-LA")} ກີບ`;
}
